var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/redux/~/lodash/_Symbol.js
// module id = 170
// module chunks = 0